import React from 'react';
import './Hero.css';
import { useLanguage } from '../LanguageContext';
import logoIcon from '../assets/images/header-logo.png';
import heroBackground from '../assets/images/hero-background.png';
import heroCenterImage from '../assets/images/hero-center.png';
import heroPhoneApp from '../assets/images/hero-right-app.png';

const Hero = () => {
  const { t, language, setLanguage } = useLanguage();

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="hero">
      <nav className="navbar">
        <div className="logo">
          <img src={logoIcon} alt="Float Logo" className="logo-icon" />
          <span className="logo-text">Float</span>
        </div>
        <div className="nav-links">
          <a href="#story" onClick={(e) => scrollToSection(e, 'story')}>{t('navStory')}</a>
          <a href="#how-it-works" onClick={(e) => scrollToSection(e, 'how-it-works')}>{t('navHowItWorks')}</a>
          <a href="#travel" onClick={(e) => scrollToSection(e, 'travel')}>{t('navTravel')}</a>
          <div className="language-selector">
            <div className="language-current">
              🌐 {language === 'en' ? 'EN' : language === 'zh' ? '中文' : language === 'ja' ? '日本語' : language === 'ko' ? '한국어' : language === 'es' ? 'ES' : language === 'fr' ? 'FR' : 'DE'}
            </div>
            <div className="language-dropdown">
              <div className="language-option" onClick={() => setLanguage('en')}>English</div>
              <div className="language-option" onClick={() => setLanguage('zh')}>中文</div>
              <div className="language-option" onClick={() => setLanguage('ja')}>日本語</div>
              <div className="language-option" onClick={() => setLanguage('ko')}>한국어</div>
              <div className="language-option" onClick={() => setLanguage('es')}>Español</div>
              <div className="language-option" onClick={() => setLanguage('fr')}>Français</div>
              <div className="language-option" onClick={() => setLanguage('de')}>Deutsch</div>
            </div>
          </div>
        </div>
      </nav>
      
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">{t('heroTitle')}</h1>
          <p className="hero-subtitle">
            {t('heroSubtitle1')}<br />
            {t('heroSubtitle2')}<br />
            <span className="highlight">{t('heroSubtitle3')}</span>
          </p>
          <div className="hero-cta">
            <p className="cta-text"><strong>{t('heroJoin')}</strong> {t('heroMeet')}<br />{t('heroFrom')}</p>
          </div>
        </div>
        
        <div className="hero-images">
          <div className="illustration">
            <img src={heroCenterImage} alt="People walking together" className="people-illustration" />
          </div>
          
          <div className="phone-mockups">
            <img src={heroPhoneApp} alt="Float App" className="phone-mockup-image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
